import React from "react";
import ReactSelect, {MultiValue, StylesConfig} from "react-select";

export type CompetenceOption = {value: string; label: string};

const selectStyles: StylesConfig<CompetenceOption, true> = {
  control: (base, state) => ({
    ...base,
    borderRadius: "12px",
    background: state.isFocused ? "#f0f0fa" : "#f5f5fd",
    border: "none",
    boxShadow: "none",
    padding: "2px 10px 3px 10px",
    font: "var(--text-regular)",
    color: "var(--text-color-regular)",
    cursor: "pointer",
    "&:hover": {borderColor: "none"},
  }),
  indicatorSeparator: () => ({display: "none"}),
  dropdownIndicator: (base) => ({
    ...base,
    color: "var(--text-color-regular)",
    svg: {width: 14, height: 14},
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "var(--text-color-regular)",
    svg: {width: 14, height: 14},
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--text-color-disabled)",
    font: "var(--text-regular)",
  }),
  menu: (base) => ({
    ...base,
    borderRadius: "16px",
    backgroundColor: "var(--color-neutral6, #f5f5fd)",
  }),
  option: (base, {isSelected, isFocused}) => ({
    ...base,
    font: "var(--text-regular)",
    color: isSelected ? "white" : "var(--text-color-regular)",
    backgroundColor: isFocused ? "#e8e8f8" : "transparent",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e8e8f8",
    borderRadius: "12px",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "var(--text-color-regular)",
    font: "var(--text-regular)",
    paddingLeft: "8px",
  }),
  multiValueRemove: (base) => ({
    ...base,
    borderRadius: "0 12px 12px 0",
    ":hover": {backgroundColor: "#d0d0e8", cursor: "pointer"},
  }),
};

type Props = {
  options: CompetenceOption[];
  value: CompetenceOption[];
  onChange: (selected: MultiValue<CompetenceOption>) => void;
  placeholder?: string;
  noOptionsMessage?: () => string;
};

export default function CompetenceSelect({options, value, onChange, placeholder, noOptionsMessage}: Props) {
  return (
    <ReactSelect<CompetenceOption, true>
      isMulti
      isClearable
      styles={selectStyles}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      noOptionsMessage={noOptionsMessage}
    />
  );
}
